import { ApplicationStore } from "src/store";

export const isMessageCenterLoading = (state: ApplicationStore) => state.messages.loading;

export const hasMessageCenterLoaded = (state: ApplicationStore) => state.messages.data !== null;

export const hasMessages = (state: ApplicationStore) =>
    (state.messages.data?.total ?? 0) + state.messages.sending.length + state.messages.failed.length > 0;

export const getMessages = (state: ApplicationStore) => state.messages.data?.messages ?? [];

export const getSendingMessages = (state: ApplicationStore) => state.messages.sending;

export const getFailedMessages = (state: ApplicationStore) => state.messages.failed;
